/**
 * CardAsync Action Creators
 */
import { Kushki } from "@kushki/js";
import { CardAsyncTokenRequest } from "@kushki/js/lib/types/card_async_token_request";
import { CardAsyncTokenResponse } from "@kushki/js/lib/types/card_async_token_response";
import { ErrorResponse } from "@kushki/js/lib/types/error_response";
import { setErrorMessage } from "components/Error/store/Actions";
import {
  hideOverlay,
  showOverlay,
} from "components/OverLay/store/ActionCreators";
import { Actions } from "containers/CardAsync/store/Actions";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { updateDisableButton } from "root/store/Reducer";
import { ICardAsyncFormProps } from "types/cajita_store";
import { ICardAsyncActionCreator } from "types/card_async_action_creator";

function getStatusValidity(state: ICardAsyncFormProps): boolean {
  let isValid: boolean = true;

  const inputs: string[] = ["emailInput"];

  for (const inputName of inputs) isValid = state[inputName].valid && isValid;

  return isValid;
}

const inputAction: (payload: IInputProps) => ICardAsyncActionCreator = (
  payload: IInputProps
): ICardAsyncActionCreator => ({
  type: Actions.UPDATE_CARD_ASYNC_INPUT,
  input: payload,
});

const disableCardAsyncAction: () => ICardAsyncActionCreator = (): ICardAsyncActionCreator => ({
  type: Actions.DISABLE_CARD_ASYNC_FORM,
});

const changeStatus: () => ICardAsyncActionCreator = (): ICardAsyncActionCreator => ({
  type: Actions.SWITCH_CARD_ASYNC_VALIDITY,
});

const setDirty: (payload: IInputProps) => ICardAsyncActionCreator = (
  payload: IInputProps
): ICardAsyncActionCreator => ({
  type: Actions.SET_CARD_ASYNC_INPUT_DIRTY,
  input: payload,
});

const updateCardAsyncToken: (payload: string) => ICardAsyncActionCreator = (
  payload: string
): ICardAsyncActionCreator => ({
  type: Actions.SET_CARD_ASYNC_TOKEN,
  token: payload,
});

function updateInput(
  payload: IInputProps
): ThunkAction<void, CajitaStore, undefined, ICardAsyncActionCreator> {
  return (
    dispatch: ThunkDispatch<CajitaStore, undefined, ICardAsyncActionCreator>,
    getState: () => CajitaStore
  ): void => {
    dispatch(inputAction(payload));
    const state: ICardAsyncFormProps = getState().card_async;
    const status: boolean = getStatusValidity(state);

    if (state.isValid !== status) dispatch(changeStatus());
  };
}

function getCardAsyncToken(
  body: CardAsyncTokenRequest
): ThunkAction<void, CajitaStore, undefined, ICardAsyncActionCreator> {
  return (dispatch: Function, getState: () => CajitaStore): void => {
    const kushki: Kushki = getState().config.kushkiJS as Kushki;

    dispatch(updateDisableButton(true));
    dispatch(showOverlay());
    kushki.requestCardAsyncToken(
      body,
      (response: CardAsyncTokenResponse | ErrorResponse) => {
        if ("token" in response) dispatch(updateCardAsyncToken(response.token));
        else {
          dispatch(setErrorMessage(response.message));
          dispatch(hideOverlay());
        }
        dispatch(updateDisableButton(false));
      }
    );
  };
}

export {
  setDirty,
  updateInput,
  getCardAsyncToken,
  changeStatus,
  disableCardAsyncAction,
};



// WEBPACK FOOTER //
// ./src/containers/CardAsync/store/ActionCreators.tsx